import AnalyticsActions from '@Actions/application/analyticsActions';
import QualityCheckActions from '@Actions/quality/qualityCheckActions';
import constants from '@Apis/constants';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Table } from 'antd';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import './style.scss';

const QCList = ({
  qualityChecksLoading, qualityChecks, getQualityChecks, selectBatch, downloadDocument,
}) => {
  useEffect(() => {
    if (selectBatch) getQualityChecks(selectBatch?.tenant_id, '', '', ['COMPLETED'], '', 1, 10, '', '', '', selectBatch?.batch_id);
  }, []);

  const columns = [
    {
      title: 'QC Number',
      dataIndex: 'qc_number',
      key: 'qc_number',
    },
    {
      title: 'Quantity',
      dataIndex: 'approved_qty',
      key: 'approved_qty',
    },
    {
      title: 'Date',
      key: 'created_at',
      render: (record) => dayjs(record?.created_at).format('DD/MM/YYYY'),
    },
    {
      title: 'COA Report',
      key: 'coa_report',
      render: (record) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => record?.quality_check_id && downloadDocument({
            url: `${constants.QUALITY_CHECK_COA}?quality_check_id=${record?.quality_check_id}&tenant_id=${selectBatch?.tenant_id}`,
            document_type: 'CERTIFICATE_OF_ANALYSIS',
            document_number: record?.quality_check_id,
            key: uuidv4(),
          })}
        >
          <FontAwesomeIcon icon={faDownload} style={{ color: !record?.quality_check_id ? '#d3d3d3' : '#2d7cf7' }} />
        </div>
      ),
    },

  ];

  const getData = () => {
    let qualityChecksCopy = JSON.parse(JSON.stringify(qualityChecks?.quality_checks));
    qualityChecksCopy = qualityChecksCopy?.map((qc) => ({
      ...qc,
      key: qc?.quality_check_id,
    }));
    return qualityChecksCopy;
  };
  return (
    <div className="qc_list_wrapper">
      <Table
        columns={columns}
        dataSource={(qualityChecks?.quality_checks && getData()) || []}
        loading={qualityChecksLoading}
        size="small"
        pagination={false}
      />
      {qualityChecks?.quality_checks && (
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6">
            <Button
              type="primary"
              loading={qualityChecksLoading}
              onClick={() => {
                const qualityCheckIds = qualityChecks?.quality_checks?.map((qc) => qc?.quality_check_id);

                if (qualityCheckIds?.length) {
                  downloadDocument({
                    url: `${constants.QUALITY_CHECK_COA}?quality_check_ids=${qualityCheckIds}&tenant_id=${selectBatch?.tenant_id}`,
                    document_type: 'CERTIFICATE_OF_ANALYSIS',
                    document_number: qualityCheckIds?.join('_'),
                    key: uuidv4(),
                  });
                }
              }}
            >
              Download All
            </Button>
          </div>
        </div>
      )}

    </div>
  );
};

const mapStateToProps = ({
  QualityCheckReducers,
}) => ({
  qualityChecksLoading: QualityCheckReducers.qualityChecksLoading,
  qualityChecks: QualityCheckReducers.qualityChecks,
});

const mapDispatchToProps = (dispatch) => ({
  getQualityChecks: (tenantId, entityId, entityName, status, qcType, page, limit, searchKeyword, startDate, endDate, batchId) => dispatch(
    QualityCheckActions.getQualityChecks(tenantId, entityId, entityName, status, qcType, page, limit, searchKeyword, startDate, endDate, batchId),
  ),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
});

QCList.propTypes = {
  qualityChecksLoading: PropTypes.bool,
  qualityChecks: PropTypes.any,
  getQualityChecks: PropTypes.func,
  selectBatch: PropTypes.any,
  downloadDocument: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QCList));
